'use client';

import Icon from '@/components/ui/AppIcon';

interface AffiliateDisclosureProps {
  partner: 'Skyscanner' | 'Booking.com' | 'Expedia';
  className?: string;
}

const AffiliateDisclosure = ({ partner, className = '' }: AffiliateDisclosureProps) => {
  return (
    <div className={`bg-surface border border-border rounded-lg p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <Icon name="InformationCircleIcon" size={20} className="text-primary flex-shrink-0 mt-0.5" />
        <div className="text-sm text-muted-foreground">
          <p className="font-semibold text-foreground mb-1">Partner Booking</p>
          <p>
            When you click "Book Now", you'll be redirected to <span className="font-semibold text-foreground">{partner}</span>, 
            our trusted booking partner. We may earn a commission from bookings made through this link at no extra cost to you. 
            All bookings are processed securely by {partner}.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffiliateDisclosure;
